import { Injectable } from '@angular/core';
import { ToastInterface } from '../interfaces/toast.interface';
import { ToastService } from './toast.service';

@Injectable()
export class ToastService2 {

    constructor(
        protected toastService: ToastService) {
    }

    /**
     * Show a success Toast.
     *
     * @param message
     * @param options
     */
    public success(message: string, options?: ToastInterface): void {
        this.toastService.success('success', message, options);
    }

    /**
     * Show a info Toast.
     *
     * @param message
     * @param options
     */
    public info(message: string, options?: ToastInterface): void {
        this.toastService.info('info', message, options);
    }

    /**
     * Show a warning Toast.
     *
     * @param message
     * @param options
     */
    public warning(message: string, options?: ToastInterface): void {
        this.toastService.warning('warning', message, options);
    }

    /**
     * Show an error Toast.
     *
     * @param message
     * @param options
     */
    public error(message: string, options?: ToastInterface): void {
        this.toastService.error('error', message, options);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/toast/services/toast2.service.ts